import { AsyncPipe } from '@angular/common'
import { Component, OnDestroy, OnInit, signal } from '@angular/core'
import { LoadingController } from '@ionic/angular/standalone'
import { Subject, takeUntil } from 'rxjs'

import { LoaderService as HttpLoaderService } from '../../services/loader.service'
import { WhiteLabelService } from '../../services/white-label.service'
import { LoadingService } from './loading.service'

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
	standalone: true,
	imports: [AsyncPipe],
})
export class LoadingComponent implements OnInit, OnDestroy {
	private readonly destroy$ = new Subject<void>()

	protected readonly manualLoading = signal(false)

	protected readonly httpLoading$ = this.httpLoaderService.getState()

	constructor(
		private readonly loadingController: LoadingController,
		private readonly loadingService: LoadingService,
		private readonly httpLoaderService: HttpLoaderService,
		protected readonly whiteLabelService: WhiteLabelService,
	) {}

	ngOnInit() {
		this.loadingService.loadingVisibility$.pipe(takeUntil(this.destroy$)).subscribe({
			next: (visible) => {
				this.updateLoadingVisibility(visible).catch((error) => console.error('Failed to update loading visibility:', error))
			},
		})
	}

	ngOnDestroy() {
		this.destroy$.next()
		this.destroy$.complete()
	}

	/**
	 * Create an ionic loading animation
	 */
	async showLoading() {
		if (!(await this.loadingController.getTop())) {
			const loading = await this.loadingController.create({
				spinner: 'bubbles',
				duration: this.loadingService.duration,
			})

			await loading.present()
		}
	}

	/**
	 * Dismiss the opened loading animation
	 * @private
	 */
	async closeLoading() {
		if (await this.loadingController.getTop()) {
			await this.loadingController.dismiss()
		}
	}

	private async updateLoadingVisibility(visible: boolean): Promise<void> {
		if (this.whiteLabelService.isV2Skin()) {
			this.manualLoading.set(visible)
			await this.closeLoading()
			return
		}

		if (visible) {
			await this.showLoading()
		} else {
			await this.closeLoading()
		}
	}
}
